import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import './styles/tokens.css';
import './styles/global.css';

import { App } from './app/App';
import { ConfigError } from './app/ConfigError';
import { envResult } from './lib/env';

const root = createRoot(document.getElementById('root')!);
root.render(
  <StrictMode>{envResult.ok ? <App /> : <ConfigError problems={envResult.problems} />}</StrictMode>,
);
